/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteManyUserDto } from '../../models/delete-many-user-dto';

export interface DeleteUserControllerDeleteMany$Params {
      body: DeleteManyUserDto
}

export function deleteUserControllerDeleteMany(http: HttpClient, rootUrl: string, params: DeleteUserControllerDeleteMany$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'count'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, deleteUserControllerDeleteMany.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'count'?: number;
      }>;
    })
  );
}

deleteUserControllerDeleteMany.PATH = '/api/user';
